import { matchesApex } from '../HostUtils';

export const TABLERUN_APEX_HOST = 'tablerun.com';

export const isTableRunHostname = (hostname: string): boolean => matchesApex(hostname, TABLERUN_APEX_HOST);
